import { useTranslation } from 'react-i18next';
import React from 'react';
import * as queries from '../../queries';
import { useQuery } from '@apollo/client';
import AuctionSum from '../../utils/AuctionSum';

const AuctionLiveCurrent = () => {
    const { t } = useTranslation();
    const { loading, error, data } = useQuery(queries.GET_CURRENCTAUCTIONS);

    if (loading) return <p>{t('Loading...')}</p>;
    if (error) return <p>{t('Error:')}{error.message}</p>;
    return (
        (<div className='main-container'>
            <h1>{t('Auction Live Current')}</h1>
            <h1>{t('Total:')}{data.allAuctions.totalCount}</h1>
            {data.allAuctions.data.map((auction, index) => (
                <AuctionSum auctionID={auction.AuctionID} />
            ))}
        </div>)
    );
};

export default AuctionLiveCurrent;